import { WOW } from 'wowjs';
export default {
  init() {
    const wow = new WOW();

    wow.init();
    $('#reachout').click(function () {
      $('#reachout_forms').toggle('slow');
      return false;
    });
    $('#close_btn').click(function () {
      $('#reachout_forms').toggle('slow');
      return false;
    });
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll >= 10) {
        $('.sticky-site-header').addClass('shadow_css');
      } else {
        $('.sticky-site-header').removeClass('shadow_css');
      }
    });

    const headers = document.querySelectorAll('.faq-question');

    headers.forEach((header) => {
      header.addEventListener('click', () => {
        const body = header.nextElementSibling;
        const isOpen = body.style.maxHeight;

        // Close all accordions
        document.querySelectorAll('.faq-answer').forEach((b) => {
          b.style.maxHeight = null;
        });

        // Remove active class from all headers
        headers.forEach((h) => h.classList.remove('active'));

        // Open clicked accordion
        if (!isOpen) {
          body.style.maxHeight = body.scrollHeight + 'px';
          header.classList.add('active');
        }
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('#navbar-primary .navbar-nav li.dropdown .nav-link').click(function (e) {
      if ($(window).width() < 1200) {
        var grandparent = $(this).next();
        if ($(this).hasClass('open1') && grandparent.hasClass('opened')) {
          document.location.href = this.href;
        } else {
          $(this).addClass('open1');
          $('#navbar-primary .navbar-nav').find('i').removeClass('opened');
          $(this).next('.dropdown-toggle1').click();
        }
      } else {
        location.href = this.href;
      }
      e.preventDefault();
    });

    $('li.dropdown > .dropdown-toggle1').on('click', function (e) {
      var current = $(this).next();
      var current1 = $(this);
      var grandparent = $(this).parent().parent();
      grandparent
        .find('.dropdown-menu:visible')
        .not(current)
        .removeClass('show1');
      grandparent.find('.dropdown-toggle1').not(current1).removeClass('opened');
      $(this).toggleClass('opened');
      current.toggleClass('show1');
      e.stopPropagation();
    });
    $('#health-service-sliders').slick({
      infinite: true,
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 10000,
      pauseOnHover: false,
      asNavFor: '.service-right-slider',
    });

    jQuery('.service-right-slider').slick({
      infinite: true,
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 10000,
      pauseOnHover: false,
      asNavFor: '#health-service-sliders',
    });
    $('#services-slider').slick({
      infinite: true,
      adaptiveHeight: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 10000,
      pauseOnHover: false,
      responsive: [{
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      ],
    });

    $(document).ready(function () {
      $('.footer-location-mob .loaction-name').on('click', function () {
        $(this).removeClass('open').toggleClass('open');
      });
    });
    var i = 2;
    $('.main').on('click', '.calevir_loadmore', function (e) {
      e.preventDefault();
      var calevir_loadmore_params = {
        'ajaxurl': '/wp-admin/admin-ajax.php',
        'posts': '',
        'current_page': i,
        'max_page': null,
      };
      var button = $(this),
        data = {
          'action': 'loadmore',
          'page': calevir_loadmore_params.current_page,
        };
      $.ajax({
        url: calevir_loadmore_params.ajaxurl,
        data: data,
        type: 'POST',
        cache: false,
        dataType: 'JSON',
        beforeSend: function () {
          button.text('Loading...');
        },
        success: function (data) {
          if (data) {
            if (data.actiondata) {
              $('#blog-result').append(data.actiondata);
            }
            button.text('Load More Blogs');
            i++;
            if (i == button.data('num')) {
              button.remove();
            }
          } else {
            button.remove();
          }
        },
      });
    });
    $('.home .banner-box').css('opacity', 0);
    $(document).ready(function () {
      $('.home .banner-box').addClass('fadeInLeft');
    }, {
      offset: '-20%',
    });
    $('.home .what-now-img').css('opacity', 0);

    $('.home .what-now-img').waypoint(function () {
      $('.home .what-now-img').addClass('fadeInRight');
    }, {
      offset: '75%',
    });
    $('.home .book-appointment .content').css('opacity', 0);

    $('.home .book-appointment .content').waypoint(function () {
      $('.home .book-appointment .content').addClass('fadeInUp');
    }, {
      offset: '75%',
    });

  },

};
document.addEventListener('DOMContentLoaded', () => {
  const languageLabels = {
    'wpml-ls-item-es': 'Mexican Flags',
    'wpml-ls-item-en': 'United States Flags',
  };
  Object.entries(languageLabels).forEach(([className, altText]) => {
    document
      .querySelectorAll(`li.${className} a .wpml-ls-flag`)
      .forEach((flag) => {
        flag.setAttribute('alt', altText);
      });
  });
});


// WEBPACK FOOTER //
// ./scripts/routes/common.js